import { Platform } from "react-native";
import * as SecureStore from "expo-secure-store";

export const MERCHANT_BRAND_KEY = "merchantBrand";

export async function setStorage(key, value) {
  try {
    if (Platform.OS === "web") {
      // Web fallback
      sessionStorage.setItem(key, value);
    } else {
      // Android / iOS
      await SecureStore.setItemAsync(key, value);
    }
  } catch (error) {
    console.log("Storage save error:", error);
  }
}

export async function getStorage(key) {
  try {
    if (Platform.OS === "web") {
      return sessionStorage.getItem(key);
    } else {
      return await SecureStore.getItemAsync(key);
    }
  } catch (error) {
    console.log("Storage read error:", error);

    return null;
  }
}

export async function removeStorage(key) {
  try {
    if (Platform.OS === "web") {
      sessionStorage.removeItem(key);
    } else {
      await SecureStore.deleteItemAsync(key);
    }
  } catch (error) {
    console.log("Storage delete error:", error);
  }
}
